import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Dashboard from "./pages/Dashboard";
import { useEffect, useState } from "react";
import store from "./Redux Store/store";
import { __hideLoader, __showLoader } from "./Redux Store/Slices/loader";
import { useDispatch } from "react-redux";
import { logout, setUserData } from "./Redux Store/Slices/auth";
import { AuthUrl } from "./urls";
import useAxiosInterceptor from "./utils/axiosInterceptors";
import ScrollToTop from "./ScrollToTop";

const PrivateRoute = () => {
  useAxiosInterceptor();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    loaderDashboard();
  }, []);

  const loaderDashboard = async () => {
    dispatch(__showLoader("Dashboard Loading..."));
    const isAuthenticated = await verifyUser();
    console.log({ isAuthenticated });

    setIsAuthenticated(isAuthenticated);

    dispatch(__hideLoader());

    if (!isAuthenticated) {
      navigate("/login");
      dispatch(logout());
      return;
    }

    return null; // Proceed with rendering the Dashboard component if authenticated
  };
  if (!isAuthenticated) return null;
  return (
    <Dashboard>
      <ScrollToTop />
      <Outlet />
    </Dashboard>
  );
};

export default PrivateRoute;

export const verifyUser = async () => {
  try {
    // Get the access token from session storage
    const token = sessionStorage.getItem("access_token");
    console.log({ token });
    if (!token) {
      console.error("Invalid or malformed token");
      return false;
    }

    // Decode the token to get the username
    const decodedToken = jwtDecode(token);
    console.log({ decodedToken });
    const username = decodedToken?.username;

    if (!username) {
      console.error("Invalid token structure: username missing");
      return false;
    }

    // Send the username to the backend for verification
    const url = `${AuthUrl.username}${username}`
    console.log({ url })
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("username", username);
    console.log({ response: response.data });

    if (response.status === 200 && response.data.status === "CONFIRMED") {
      store.dispatch(setUserData({ ...response.data, ...decodedToken }));

      return true; // Verified
    } else {
      console.error("Verification failed");
      return false;
    }
  } catch (error) {
    console.error("Authentication error:", error.message);
    return false; // Not verified
  }
};
